import { lazy } from "react";
// import Dashboard from "../components/dashboard";
import BadgeIcon from "@mui/icons-material/Badge";

const LiveViewPage = lazy(() => import("../dashboardV2/ListView"));
const Dashboard = lazy(() => import("../components/dashboard"));

const dashboardRoute = {
  icon: BadgeIcon,
  name: "Dashboard",
  before: "Role",
  path: "dashboard",
  link: "/settings",
  index: 5,
  superAdminView: false,
  permission: "Dashboard-Read",

  children: [
    {
      path: "",
      element: <Dashboard />,
      name: "Dashboard",
      link: "",
      permission: "Dashboard-Read",
      icon: BadgeIcon,
      index: 1,
    },
    {
      path: "live-dashboard",
      element: <LiveViewPage />,
      name: "Live Dashboard",
      link: "dashboard/live-dashboard",
      permission: "Dashboard-Read",
      icon: BadgeIcon,
      index: 2,
    },
    // {
    //   path: "dashboardV2",
    //   element: <DashboardPage />,
    //   name: "Dashboard",
    //   link: "admin-dashboard/dashboardV2",
    //   permission: "Dashboard-Read",
    //   icon: BadgeIcon,
    //   index: 1,
    // },
  ],

  // {
  //   path: "dashboard",
  //   element: <DashboardPage />,
  //   // name: "Dashboard",
  //   link: "dashboard",
  //   icon: DashboardIcon,
  // },
  // {
  //   icon: BadgeIcon,
  //   name: "Dashboard",
  //   link: "dashboardV2",
  //   path: "dashboardV2",
  //   index: 5,
  //   superAdminView: false,
  //   element: <DashboardPage />,
  //   permission: "Dashboard-Read",
  // },
  // {
  //   icon: BadgeIcon,
  //   name: "Dashboard",
  //   link: "dashboardV2/liveView",
  //   path: "dashboardV2/liveView",
  //   // index: 5,
  //   // superAdminView: false,
  //   element: <LiveViewPage />,
  //   permission: "Dashboard-Read",
  // },
};
// ];
export default dashboardRoute;
